import { FC } from "react";
import "./style.css";
import Select from "react-dropdown-select";

interface Props {
  iterations: any[];
  workItems: any[];
  uatCompletedWorkItems: any[];
  prdCompletedWorkItems: any[];
  selectedIteration: any;
  onSelectIteration: (iteration: any) => void;
}

export const ReleasePacksList: FC<Props> = ({
  iterations,
  workItems,
  uatCompletedWorkItems,
  prdCompletedWorkItems,
  selectedIteration,
  onSelectIteration,
}) => {
  const handleIterationChange = (value: any) => {
    if (value && value[0]) {
      onSelectIteration(value[0]?.value);
    }
  };

  return (
    <>
      <div className="container">
        <div className="headers">
          <div className="header-item-env"></div>
          <div className="header-item-env">UAT</div>
          <div className="header-item-env">PRD</div>
        </div>
        <div className="headers">
          <div className="header-item">
            <div className="header-select">
              <Select
                placeholder="Select sprint..."
                onChange={(values: any) => handleIterationChange(values)}
                options={iterations?.map((i) => ({
                  value: i.id,
                  label: i.name,
                }))}
                values={[{value: selectedIteration?.id, label: selectedIteration?.name}]}
              />
            </div>
          </div>
          <div className="header-item">Work items - completed</div>
          <div className="header-item">Work items - completed</div>
        </div>
        <div className="content">
          <div className="content-item">
            {workItems.map((wi) => (
              <div>
                <a className="content-item-link" href={wi?.url}>
                  [{wi?.id}] {wi?.fields?.title} ({wi?.fields?.state})
                </a>
              </div>
            ))}
          </div>
          <div className="content-item">
            {uatCompletedWorkItems.map((wi) => (
              <div>
                <a className="content-item-link" href={wi?.url}>
                  [{wi?.id}] {wi?.fields?.title} ({wi?.fields?.state})
                </a>
              </div>
            ))}
          </div>
          <div className="content-item">
            {prdCompletedWorkItems.map((wi) => (
              <div>
                <a className="content-item-link" href={wi?.url}>
                  [{wi?.id}] {wi?.fields?.title} ({wi?.fields?.state})
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
